<template>
  <div>
       <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" layout='inline' :onFinish='pageSearchChange'>
      <a-form-item label="关键词" name='keyword'>
        <a-input v-model:value="search.keyword" placeholder="请输入标题进行搜索" :style="{'width':'270px'}" />
      </a-form-item>
      <a-form-item label="状态" name='status'>
        <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button class="m-r-10" type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
      <template v-slot:action="{ record }">
        <a v-has:publicTemplateStatus='()=>addTemplate(record)' href="javascript:;" v-if="record.brand_tmp_id==0">启用</a>
        <a v-has:publicTemplateStatus="()=>miniTemplateDisable(record)" href="javascript:;" v-else>{{record.brand_tmp_status==1?'禁用':'启用'}}</a>
        <!-- 2022-2-21 狗测试和狗产品让注释掉 -->
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" />
  </div>
</template>

<script>
  import { DownOutlined } from "@ant-design/icons-vue";
  import { inject, reactive, ref, toRefs } from "vue";
  import { getPublicTmp, delPublicTmp, statusPublicTmp,createPublicTmp } from "@/api/message.js";
  import { iscode } from "@/utils/app";
  import { message } from 'ant-design-vue';
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    keyword: ''
  };
  export default {
    // components: { DownOutlined },
    setup() {
      let columns = [
        {
          title: "标题",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "关键词",
          dataIndex: "tmp_key",
          key: "tmp_key",
        },
        {
          title: "使用场景说明",
          dataIndex: "sceneDesc",
          key: "sceneDesc",
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          customRender:({record})=>{
            return record.brand_tmp_status==1?'启用':'禁用'
          }
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        }
      ];
      const state = reactive({
        receiverVisible: false,
        confirmLoading: false,
        selectedRowKeys: []
      })

      const $Modal = inject('$Modal')

      const router = inject('$router')
      const set = (id) => {
        router.push({ path: '/messageCenter/subscription/singleSet', query: { type: 'single', selectedRowKeys: id } })
      }
      const allSet = () => {
        if (!state.selectedRowKeys.length) {
          message.error('请勾选订阅消息')
          return;
        }
        router.push({ path: '/messageCenter/subscription/set', query: { type: 'more', selectedRowKeys: JSON.stringify(state.selectedRowKeys) } })
      }
      const onSelectChange = (selectedRowKeys) => {
        state.selectedRowKeys = selectedRowKeys;
      }
      //初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      let total = ref(0)
      let listLoading = ref(false);
      let data = ref([]);
      const initData = async (values) => {
        data.value = [];
        listLoading.value = true;
        let res = await getPublicTmp(values).then((res) => res.data);
        listLoading.value = false;
        if (iscode(res)) {
          data.value = res.data.data
          total.value = res.data.total
        } else {
          message.error(res.msg);
        }
      };
      initData(search.value)
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };

      // 修改状态
      const miniTemplateDisable = (e) => {
        $Modal.confirm({
          centered: true,
          content: `确定要${e.brand_tmp_status == 1 ? '禁用' : '启用'}该模板么`, onOk: async () => {
            let res = await statusPublicTmp({ id: e.brand_tmp_id, status: e.brand_tmp_status == 1 ? 0 : 1 }).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      // 删除模板
      const delMiniTemplate = (e) => {
        $Modal.confirm({
          centered: true,
          content: '确定要删除该模板么', onOk: async () => {
            let res = await delPublicTmp({ id: e.brand_tmp_id ,brand_tmp_id:e.brand_tmp_id }).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      // 添加模板
      const addTemplate=async (e)=>{
       const hide = message.loading('正在加载中...', 0);
       let result=await createPublicTmp({template_id:e.id}).then(res=>res.data).catch(error=>error)
       setTimeout(hide);
       if(iscode(result,true)){
         initData(search.value)
       }
      }
      return {
        search,
        columns,
        pageCurrentChange,
        pageSizeChange,
        listLoading,
        data,
        total,
        ...toRefs(state),
        set,
        allSet,
        onSelectChange,
        miniTemplateDisable,
        delMiniTemplate,
        addTemplate,
        pageSearchChange
      };
    },
  };
</script>